module.exports = __webpack_public_path__ + "img/1557614059968339970.b94d38e4.png";